import { gql } from '@apollo/client';

export const COMPANY_FRAGMENT = gql`
  fragment companyValues on Company {
    id
    defaultProjectId
    tenantId
    name
    headquarter
    industry {
      id
      name
    }
    subIndustry {
      id
      name
    }
    status
    employeesNum
    companyDomain
    accessScope
    accountType
    shortTermUpperBound
    mediumTermUpperBound
    llmMonthlyBudgetEur
    llmBudgetEnforcementEnabled
  }
`;
